module.exports = __webpack_public_path__ + "img/d201303-1.0fef5b13.jpg";